import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import Swal from "sweetalert2"; // ⭐ Pop-up ke liye

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const sendOtp = async (e) => {
    e.preventDefault(); 

    if (!email) {
      setError("Please enter your email");
      return;
    }

    try {
      const res = await axios.post(
        `${API_BASE_URL}/parent/forgot-password`,
        { email }
      );

      if (res.data.success) {
        // ⭐ Alert ki jagah beautiful Pop-up
        Swal.fire({
          title: 'Success!',
          text: 'OTP sent successfully to your email ✅',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Verify Now'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/parent/verify", {
              state: { email }
            });
          }
        });
      }

    } catch (err) {
      setError(
        err.response?.data?.message ||
        "Failed to send OTP"
      );
    }
  };

  return (
    <div style={{
      textAlign: "center",
      padding: "60px",
      display: "flex",
      justifyContent: "center",
      backgroundImage:
        "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight:"700px"
    }}>

      <div className="container mt-5 col-md-4" style={{display:"flex",justifyContent:"center",alignItems:"center"}}>

        <form
          className="form-control p-4 shadow"
          style={{
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.3)"
          }}
          onSubmit={sendOtp} 
        >

          <h3 className="p-4 text-light">Forgot Password</h3>

          <input
            type="email"
            placeholder="Enter Email"
            className="form-control w-75 text-center mx-auto"
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
            }}
          />

          <br />

          {error && (
            <p style={{ color: "red" }}>{error}</p>
          )}

          <button
            type="submit"
            className="animated-btn btn border-1 w-75 border-light text-light"
          >
           <span>Send OTP</span>
          </button>

          <div className="text-light pt-3 small">
            Remember password?
            <Link to="/parent/login" className="text-light fw-bold text-decoration-none ms-1">
              Back to Login
            </Link>
          </div>

        </form>

      </div>
    </div>
  );
}

export default ForgotPassword;
